"use client"
import FAQImage from "+/faq.webp";
import Image from "next/image";
import { useState } from "react";
import Accordion from "./ui/accordion.component";
import type { FAQ } from "@/types/data.types";

interface FAQProps {
  faqs: FAQ[];
}

export default function FAQ({ faqs }: FAQProps) {
  const [openedAccordion, setOpenedAccordion] = useState<number[]>([]);

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <section className="flex mx-10 items-center justify-center gap-20 my-20 py-20">
      <Image
        src={FAQImage}
        alt="FAQ"
        className="hidden lg:block rounded-r w-[30rem] object-cover"
      />

      <div className="max-w-xl text-center lg:text-start space-y-6">
        <h2 className="text-3xl lg:text-5xl font-semibold text-white">
          Frequently asked <br /> questions
        </h2>
        <p className="text-white/80">
          Davis Construction Group: A family-owned business delivering top-tier
          construction services to Broward County
        </p>

        <div className="space-y-2 text-xs sm:text-base">
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              question={faq.question}
              response={faq.answer}
              open={openedAccordion.includes(index)}
              onOpen={() => {
                setOpenedAccordion([index]);
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
